import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MixedIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="currentColor"
    title={t`Mixed`}
    {...props}
    testID="cart-icon"
  >
    <Path
      fill="currentColor"
      d="M4 5.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 4 5.25Zm4 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25Zm4 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z"
    />
  </Icon>
);
